import { View, StyleSheet, Platform, KeyboardAvoidingView } from 'react-native'
import { useTheme } from '@react-navigation/native';
import React, { useState } from 'react';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import DropDownPicker from 'react-native-dropdown-picker';
import { useTranslation } from 'react-i18next';

const CustomDropDownWithIcons = ({ defValue, setValue, options, placeholder = null, disabled = false, type = "PRIMARY", loading = false, multiple = false,
  direction = "BOTTOM", zIndex = 50000
}) => {

  const { t } = useTranslation();
  const { colors } = useTheme();
  const styles = makeStyles(colors);
  const [open, setOpen] = useState(false);

  var currentValue = defValue;

  return (
    <KeyboardAvoidingView>
      <DropDownPicker
        multiple={multiple}
        placeholder={placeholder !== null ? placeholder : t('common:selectItem')}
        open={open}
        value={defValue}
        items={options}
        setOpen={setOpen}
        setValue={(value) => {
          currentValue = value;
          setValue(value);
        }}
        itemKey="value"
        disabled={disabled}
        itemSeparator={true}
        listItemContainerStyle={styles.listItemContainerStyle}
        listItemLabelStyle={styles.listItemLabelStyle}
        itemSeparatorStyle={styles.itemSeparatorStyle}
        zIndex={zIndex}
        labelStyle={currentValue === "" ? [styles.labelStyle, styles.emptySelected] : styles.labelStyle}
        listMode={Platform.OS === 'web' ? 'SCROLLVIEW' : 'MODAL'}
        dropDownContainerStyle={[
          { minHeight: 300, },
          styles[`container_${type}`]]}
        dropDownDirection={direction}
        modalAnimationType="fade"
        modalContentContainerStyle={styles.modalContentContainerStyle}
        placeholderStyle={styles.placeholderStyle}
        searchable={true}
        searchPlaceholder={`${t('common:search')}...`}
        searchPlaceholderTextColor="#a1a1a1"
        searchContainerStyle={styles.searchContainerStyle}
        searchTextInputStyle={styles.searchTextInputStyle}
        style={[
          styles.container,
          styles[`container_${type}`]
        ]}
        ArrowDownIconComponent={() => {
          return <Ionicons
            name="chevron-down"
            style={styles.icon}
          />
        }}
        ArrowUpIconComponent={() => {
          return <Ionicons
            name="chevron-up"
            style={styles.icon}
          />
        }}
        TickIconComponent={() => {
          return <Ionicons
            name="checkmark-sharp"
            style={styles.checkmark}
          />
        }}
        CloseIconComponent={() => {
          return <Ionicons
            name="close-sharp"
            style={styles.close}
          />
        }}
        autoScroll={true}
        translation={{
          NOTHING_TO_SHOW: loading ? t('common:loading') : t('common:noResultsFound')
        }}
        listMessageTextStyle={styles.listMessageTextStyle}
      />
    </KeyboardAvoidingView>

  );
};

const makeStyles = (colors) => StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background_dropdown,
    borderRadius: 10,
    borderWidth: 1.5,
    borderColor: colors.border_card,
    padding: Platform.OS === "web"  ? 7 : 10,
    paddingHorizontal: Platform.OS !== "web" ? 10 : 7,
    marginVertical: 5,
    shadowColor: 'rgba(92, 143, 26, 1)',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 8,
    elevation: 2,
  },

  container_MYPROFILE: {
    width: '100%',
    backgroundColor: colors.background_dropdown,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: colors.border_card,
    padding: 10,
  },

  input_MYPROFILE: {
    fontSize: 16,
    color: colors.text_primary,
    paddingHorizontal: 0,
  },

  container_ERROR: {
    flex: 1,
    width: "100%",
    backgroundColor: colors.background_dropdown,
    borderColor: 'red',
    borderRadius: 10,
    borderWidth: 1,
    padding: 10,
  },

  container_PARTICIPANT: {
    width: '100%',
    backgroundColor: colors.background_dropdown,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: colors.border_card,
    padding: 10,
  },

  input_PARTICIPANT: {
    fontSize: 16,
    color: colors.text_primary,
    paddingHorizontal: 0,
  },

  container_PART: {
    backgroundColor: colors.background_dropdown,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: colors.border_card,
    margin: 10,
  },

  input_PART: {
    fontSize: 16,
    color: colors.text_primary,
  },

  container_PRIMARY: {
    backgroundColor: colors.background_dropdown,
    borderRadius: 10,
    width: '60%',
  },

  container_FULL: {
    flex: 1,
    backgroundColor: colors.background_dropdown,
    borderRadius: 10,
    borderColor: colors.border_card,
    borderWidth: 2,
    width: '94%',
    marginVertical: 5,
  },
  container_ASSM: {
    flex: 1,
    backgroundColor: colors.background_dropdown,
    zIndex: '1',
    borderRadius: 10,
    borderWidth: 2,
    borderColor: colors.border_card,
    width: '90%',
    padding: 10,
    height: '60%',
    margin: 10,
  },
  input_ASSM: {
    fontSize: 12,
    color: colors.text_primary,
    paddingHorizontal: 0,
  },
  icon: {
    fontSize: 20,
    color: '#a1a1a1',
    paddingRight: 10,
  },

  listItemContainerStyle: {
    height: 60,
  },

  listItemLabelStyle: {
    fontSize: 16,
    color: colors.text_primary,
    paddingRight: 15,
    fontFamily: 'Roboto-Medium',
  },

  itemSeparatorStyle: {
    backgroundColor: "#a1a1a147",
  },

  labelStyle: {
    fontSize: 16,
    paddingHorizontal: 5,
    color: colors.text_primary,
    paddingRight: 30,
    fontFamily: 'Roboto-Medium',
  },

  emptySelected: {
    color: '#a1a1a1',
  },

  placeholderStyle: {
    color: "#a1a1a1",
    fontSize: 16,
    paddingHorizontal: 5,
    fontFamily: 'Roboto-Medium',
  },

  searchContainerStyle: {
    borderBottomColor: "#e8e8e8",
  },

  searchTextInputStyle: {
    fontSize: 16,
    fontFamily: 'Roboto-Medium',
    color: colors.text_primary,
    borderColor: colors.border_card,
  },

  modalContentContainerStyle: {
    backgroundColor: colors.background_dropdown_with_icons,
  },

  listMessageTextStyle: {
    fontSize: 16,
    fontFamily: 'Roboto-Medium',
    color: colors.text_primary,
  },

  checkmark: {
    fontSize: 20,
    color: colors.buttons_primary,
  },

  close: {
    fontSize: 30,
    color: '#a1a1a1',
  },

  container_NEW_DOCUMENT: {
    flex: 1,
    width: '98%',
    backgroundColor: colors.background_dropdown,
    borderRadius: 10,
    borderWidth: 2,
    padding: 10,
    margin: 10,
    borderColor: colors.border_card,
  },

  input_NEW_DOCUMENT: {
    fontSize: 16,
    color: colors.text_primary,
    paddingHorizontal: 0,
  },

  container_SELECT_EMPLOYEE: {
    backgroundColor: colors.background,
  },

  input_SELECT_EMPLOYEE: {
    fontSize: 14,
    color: colors.text_primary,
    paddingHorizontal: 0,
  },

  container_EDIT_EMPLOYEE: {
    borderRadius: 10,
    flex: 1,
    width: "100%",
    padding: 7,
    margin: 5,
  },

  container_SERVLINES: {
    flex: 1,
    width: "90%",
    marginLeft: "3%",
  },

  container_DEPARTMENTS: {
    borderWidth: 2,
    elevation: 5,
    shadowColor: colors.card_line,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.3,
    shadowRadius: 5,
    flex: 1,
    borderRadius: 10,
    width: "90%",
    marginLeft: "3%",
    padding: 4,
  },


});

export default CustomDropDownWithIcons;